/**
 * Fenêtre de rejoignabilité d'une salle vidéo (cours particulier). Pur (aucun
 * import). MIROIR Deno : supabase/functions/_shared/visio-join-window.ts —
 * garder synchro.
 *
 * ⚠️ Ceci est une aide UX (activer/désactiver le bouton "Rejoindre la salle"),
 * PAS la barrière de sécurité — celle-ci vit en plpgsql dans
 * `get_or_create_visio_room`/`send_visio_room_message` (packages/db/migrations/
 * 0233_video_rooms.sql, 0234_visio_room_messages.sql), qui sont les seuls
 * juges. Un client qui bricolerait ces constantes ne débloquerait rien.
 */

export const VISIO_JOIN_LEAD_MS = 10 * 60_000;
export const VISIO_JOIN_GRACE_MS = 15 * 60_000;

/**
 * `endedAtMs` = fin RÉELLE (le tuteur a TERMINÉ la réunion, migration 0249) :
 * la salle n'est alors plus rejoignable, quelle que soit la fenêtre horaire.
 * `null`/`undefined` = jamais terminée explicitement.
 */
export function isVisioRoomJoinable(
  nowMs: number,
  startsAtMs: number,
  endsAtMs: number,
  endedAtMs?: number | null,
): boolean {
  if (endedAtMs != null) return false;
  return nowMs >= startsAtMs - VISIO_JOIN_LEAD_MS && nowMs <= endsAtMs + VISIO_JOIN_GRACE_MS;
}

/**
 * Un rendez-vous reste "à venir" pour l'affichage dashboard tant que sa salle
 * est encore rejoignable — pas seulement avant son heure de début. Sinon un
 * rendez-vous "Maintenant" (starts_at = now) disparaît du dashboard dès la
 * seconde suivante, alors qu'il reste joignable pendant VISIO_JOIN_GRACE_MS.
 *
 * Un rendez-vous TERMINÉ par le tuteur (`endedAtMs`) est « passé » immédiatement,
 * sans attendre la fenêtre de grâce.
 */
export function isRendezVousUpcoming(
  nowMs: number,
  endsAtMs: number,
  endedAtMs?: number | null,
): boolean {
  if (endedAtMs != null) return false;
  return nowMs <= endsAtMs + VISIO_JOIN_GRACE_MS;
}

/** ISO (`tutor_booking_reservations.ended_at`) → ms ; `null` si la réunion n'a jamais été terminée explicitement. */
export function toEndedAtMs(endedAt: string | null | undefined): number | null {
  return endedAt ? new Date(endedAt).getTime() : null;
}
